import React, { useEffect, useRef, useState } from "react";
import Button from "../../components/common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { managementUserAction, masterActions, authActions } from "../../_store";
import { history } from "../../_helpers";
import { decryptData, encryptData } from "../../utils/encryptDecrypt";
import ManagementUserForm from "./ManagementUserForm";
import FacilityAdminMenuAccess from "./FacilityAdminMenuAccess";
import managementUserSchema from "../../validation/managementUserSchema";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import { StoredProcedures, UserRoleType, MenuItem } from "../../_helpers/enumerator";
import { useLocation } from "react-router-dom";

function EditManagementUser() {
  const { managementUserInfo, managementUserData } = useSelector(
    (state) => state.managementUser
  );
  const childRef = React.useRef();
  const dispatch = useDispatch();
  const location = useLocation();
  // const location = useLocation();
  // const { id: ManagementUserID } = location.state || {}; // Extract ManagementUserID from state

  const { user, commonFacilityCode: FacilityID } = useSelector((x) => x.auth); // Get current authenticated user

  // const { commonFacilityCode: FacilityID } = useSelector(
  //   (state) => state.master
  // ); // Facility ID (commonFacilityCode) from master state

  // Load facility dropdown on component mount
  const prevFacilityCodeRef = useRef(FacilityID);

  useEffect(() => {
    if (prevFacilityCodeRef.current !== FacilityID) {
      history.navigate("ManagementUserList");
    }
  }, [FacilityID]);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, [dispatch]);

  let userInfo = { ...managementUserData };

  const [showExtraFeild, setShowExtraFeild] = useState(false); // Toggle visibility for extra fields (PDS Permission, isAllowtoAccessOthersPDForm)
  const [errorMessage, setErrorMessage] = useState({}); // Local state for managing form error messages

  //Get dropdown Values
  useEffect(() => {
    dispatch(managementUserAction.GetUserRole());
    dispatch(masterActions.GetStateList());
  }, [dispatch]);

  // JOI validation function
  const validate = async () => {
    try {
      await managementUserSchema.validateAsync(managementUserData, {
        abortEarly: false,
      });
      return {};
    } catch (err) {
      const validationErrors = {};
      err.details.forEach((error) => {
        const field = error.path[0]; // Get the actual field name from the error path
        validationErrors[field] = error.message; // Use the correct field name
      });
      return validationErrors;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = await validate();
    setErrorMessage(validationErrors);
    if (Object.keys(validationErrors).length !== 0) {
      return;
    }

    const encryptPassword = encryptData(userInfo?.UserPassword);

    userInfo.UserPassword = encryptPassword;
    userInfo.FacilityID = FacilityID || 0;
    userInfo.CreatedBy = user?.ManagementUserID;
    userInfo.type_ManagementUserMenuPermission = userInfo?.type_ManagementUserMenuPermission?.filter((menu) => {

      // Define allowed roles for each menu
      const allowedRoles = {
        //"Management Users"
        [MenuItem.UserMenuItem]: [12],
        //Dashboard
        [MenuItem.DashboardMenuItem]: [2, 3, 12, 13],
        //Documents
        [MenuItem.DocumentsMenuItem]: [2, 12],
        //"Postal Mail" 
        [MenuItem.PostalMailMenuItem]: [2, 3, 6, 12, 13],
        // Lockdown 
        [MenuItem.LockdownMenuItem]: [2, 12],
        // Inmates 
        [MenuItem.InmatesMenuItem]: [2, 6, 12, 13],
        // "Public Users"
        [MenuItem.PublicUsersMenuItem]: [2, 6, 12],
        // "Staff Request"
        [MenuItem.RequestsOrGrievancesMenuItem]: [2, 3, 6, 12, 13],
        //Messages 
        [MenuItem.MessagesMenuItem]: [2, 3, 6, 12, 13],
        //Photos
        [MenuItem.PhotosMenuItem]: [2, 3, 6, 12, 13],
        // Keywords
        [MenuItem.KeywordsMenuItem]: [2, 6, 12],
        // Notices
        [MenuItem.NoticesMenuItem]: [2, 3, 12, 13],
        //"Connection Requests"
        [MenuItem.ConnectionRequests]: [2, 3, 6, 12, 13],
        //Reporting
        [MenuItem.Reporting]: [2, 12],
      };

      // Check if the MenuName exists in the allowedRoles object and if the user's role is included in the allowed roles for that menu
      return allowedRoles[menu.managementMenuID]?.includes(managementUserData.UserRoleID) || false;
    });


    dispatch(managementUserAction.UpdateManagementUser(userInfo)).then(
      (res) => {
        const successMessages = {
          1: { text: `User Information saved successfully`, icon: "success" },
          2: { text: `User Information Updated successfully`, icon: "success" },
          "-1": { text: `Operation Failed`, icon: "error" },
          "-2": { text: `E-mail already exist.`, icon: "error" },
          "-3": { text: `Username already exist.`, icon: "error" },
        };

        const message = successMessages[res?.payload.IsSucceed];
        showToastNotification(message.text, message.icon);
        if (res?.payload.IsSucceed === 1) {
          // Insert Management User Activity Log
          //dispatch(managementUserAction.resetManagementUserSearchData());
          dispatch(
            authActions?.ManagementUserActivityLog({
              ManagementUserID: user?.ManagementUserID,
              facilityID: FacilityID,
              ProcedureName: StoredProcedures?.MangementUserCPU,
              UserAction: `Created a New Management User (UserName - ${managementUserData?.Username})`,
            })
          );

          if (message) {
            history.navigate("/Admin/ManagementUserList");
            dispatch(managementUserAction.clearmanagementUserData());
          }
        } else if (res?.payload.IsSucceed === 2) {
          // Insert Management User Activity Log
          //dispatch(managementUserAction.resetManagementUserSearchData());
          dispatch(
            authActions?.ManagementUserActivityLog({
              ManagementUserID: user?.ManagementUserID,
              facilityID: FacilityID,
              ProcedureName: StoredProcedures?.MangementUserCPU,
              UserAction: `Updated Details in Management User (ManagementUserID - ${managementUserData?.ManagementUserID})`,
            })
          );

          if (message) {
            history.navigate("/Admin/ManagementUserList");
            dispatch(managementUserAction.clearmanagementUserData());
          }
        }
      }
    );
  };

  //Reset
  const handleReset = () => {
    // Clear error messages
    setErrorMessage({});

    // Remove input-error class from all input fields
    const errorElements = document.querySelectorAll(".input-error");
    errorElements.forEach((element) => {
      element.classList.remove("input-error");
    });

    // Dispatch reset action to clear form data
    if (managementUserInfo && Object.keys(managementUserInfo).length > 0) {
      let params = { ...managementUserData };

      params = {
        ...params,
        ManagementUserID: managementUserInfo.ManagementUserID,
        UserRoleID: managementUserInfo.UserRoleID,
        FirstName: managementUserInfo.FirstName,
        MiddleName: managementUserInfo.MiddleName,
        LastName: managementUserInfo.LastName,
        Username: managementUserInfo.UserName,
        UserPassword: decryptData(managementUserInfo?.UserPassword), // Decrypting password before showing it in the form
        ActiveStatus: managementUserInfo.ActiveStatus,
        Email: managementUserInfo.Email,
        Address1: managementUserInfo.Address1
          ? managementUserInfo.Address1
          : "",
        City: managementUserInfo.City,
        StateNameID: managementUserInfo.StateNameID,
        ZIP: managementUserInfo.ZIP,
        PhoneNumber: managementUserInfo.PhoneNumber,
        isPublicDefenderServicesAccess:
          managementUserInfo.IsPublicDefenderServicesAccess,
        isAllowtoAccessOthersPDForm:
          managementUserInfo.IsAllowtoAccessOthersPDForm === "False" ? 0 : 1,
      };

      // Check for specific UserRoleIDs to toggle extra field visibility
      if (
        managementUserInfo.UserRoleID === UserRoleType.PublicDefender ||
        managementUserInfo.UserRoleID === UserRoleType.PublicDefenderAdmin
      ) {
        setShowExtraFeild(true);
      } else {
        setShowExtraFeild(false);
      }

      // Dispatching action to set the user data into the local Redux store state
      dispatch(managementUserAction.setmanagementUserData(params));
    } else {
      dispatch(managementUserAction.resetForm());
    }
    if (childRef.current) {
      childRef.current.UpdateMenulist(); // Call the reset function in the child
      childRef.current.ResetPostMailList();
    }
    dispatch(
      managementUserAction.LoadUserAccessibleRequestForm({
        ManagementUserID: managementUserInfo.ManagementUserID,
        FacilityID: FacilityID,
      })
    );
  };

  //Back go back to the ManagementList
  const handleBack = () => {
    dispatch(managementUserAction.clearManagementUserInfo());
    dispatch(managementUserAction.resetForm());
    dispatch(managementUserAction.resetMenuList());
    history.navigate("/Admin/ManagementUserList");
  };

  return (
    <div>
      <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
        <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
            <h2 className="form_title_uppercase text-color">Edit User</h2>
            <Button
              variant="primary"
              className="me-2"
              label={"Back"}
              icon={"fa-solid fa-angle-left"}
              type={"button"}
              status={"primary"}
              onClick={handleBack}
              disabled={false}
            />
          </div>

          <ManagementUserForm
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            showExtraFeild={showExtraFeild}
            setShowExtraFeild={setShowExtraFeild}
            isEdit={true}
          />

          <FacilityAdminMenuAccess ref={childRef} />
          <div className="d-flex flex-wrap justify-content-center mt-3 gap-3">
            <Button
              label="Update"
              status="primary"
              icon={"fa-solid fa-pen-to-square"}
              type="submit"
              onClick={handleSubmit}
            />
            <Button
              label="Reset"
              status="secondary"
              type="button"
              icon={"fa-solid fa-rotate-right"}
              onClick={handleReset}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(EditManagementUser);
